export { default } from './ForecastGraphWind';
